import {} from '@emotion/react';
import { Components, Theme } from '@mui/material';
import { button } from '@/config/overrides/button';
import { card } from '@/config/overrides/card';
import { dialog, dialogActions, dialogContent, dialogTitle } from '@/config/overrides/dialog';
import { inputLabel } from '@/config/overrides/inputLabel';
import { listItemButton } from '@/config/overrides/list-item-button';
import { listItemText } from '@/config/overrides/list-item-text';
import { menuItem } from '@/config/overrides/menu-item';
import { popover } from '@/config/overrides/popover';
import { selectMui as select } from '@/config/overrides/select';
import { skeleton } from '@/config/overrides/skeleton';
import { tab } from '@/config/overrides/tab';
import { tableContainer, tableRow } from '@/config/overrides/table';
import { textfield } from '@/config/overrides/textfield';
import { divider } from '@/config/overrides/divider';
import { muiswitch } from '@/config/overrides/switch';
import { iconButton } from '@/config/overrides/icon-button';
import { tooltip } from '@/config/overrides/tooltip';

export const overrides: Components<Omit<Theme, 'components'>> = {
  MuiButton: button,
  MuiCard: card,
  MuiDivider: divider,
  MuiPopover: popover,
  MuiListItemButton: listItemButton,
  MuiListItemText: listItemText,
  MuiMenuItem: menuItem,
  MuiTextField: textfield,
  MuiTab: tab,
  MuiDialog: dialog,
  MuiDialogContent: dialogContent,
  MuiDialogActions: dialogActions,
  MuiDialogTitle: dialogTitle,
  MuiSkeleton: skeleton,
  MuiSelect: select,
  MuiInputLabel: inputLabel,
  MuiTableContainer: tableContainer,
  MuiTableRow: tableRow,
  MuiSwitch: muiswitch,
  MuiIconButton: iconButton,
  MuiTooltip: tooltip
};
